"use client";
import { useContext, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { SketchPicker } from "react-color";
import Button from "./Button";
import { icons } from "./icons";
import { AppContext } from "./AppContext";
import { deepCopy } from "@/functions/fns";

export default function ColorIcon({
  arrayIdx,
  idx,
  value,
  isHilighted,
  isBg,
  isCustomBg,
}) {
  const { setBg, copyColor, setCopyColor, setConfig, config, setCustomBg } =
    useContext(AppContext);
  const [open, setOpen] = useState(false);

  const btnRef = useRef(null);

  const submitColor = (color) => {
    if (isBg) {
      setBg(color);
      setCustomBg(false);
    } else if (isCustomBg) {
      setCustomBg(color);
    } else {
      const newConfig = deepCopy(config);
      newConfig[arrayIdx].colors[idx] = color;
      setConfig(newConfig);
    }
  };
  const onChange = (v) => {
    const { h, s, l, a } = v.hsl;
    const color = `hsla(${h},${parseInt(s * 100)}%,${parseInt(l * 100)}%,${a})`;
    submitColor(color);
  };

  const deletePoint = () => {
    const displayDeleteCondition = config?.[arrayIdx]?.colors?.length > 1;
    const newConfig = deepCopy(config);
    if (displayDeleteCondition) {
      Object.keys(newConfig[arrayIdx]).forEach((k) => {
        if (k !== "blend") newConfig[arrayIdx][k].splice(idx, 1);
      });
    } else {
      newConfig.splice(arrayIdx, 1);
    }
    setConfig(newConfig);
    setOpen(false);
  };

  const opener = () => {
    const { current } = btnRef;
    let { left, top, width, height } = current.getBoundingClientRect();
    top += 300;
    if (top > window.outerHeight - 300) top -= 400;
    const btnClass = "border border-dark-200 px-2 bg-white text-dark-500";
    return ReactDOM.createPortal(
      <>
        <div className="z fixed inset-0" onClick={() => setOpen(false)} />
        <div className="fixed" style={{ left, top, width, height }}>
          <div className="absolute bottom-0 right-full -mb-10 mr-2 flex flex-col overflow-hidden rounded-lg bg-white shadow-xl">
            <div className="p-3">
              <SketchPicker color={value} onChange={onChange} />
            </div>
            <div className="mt-2 flex justify-end gap-2 border-t border-dark-200 bg-dark-100 p-2">
              {!isBg && (
                <Button
                  className={
                    btnClass +
                    " hover:border-transparent hover:bg-red-500 hover:text-white"
                  }
                  onClick={() => deletePoint()}
                >
                  {icons.close}
                  Delete
                </Button>
              )}
              <Button
                className={btnClass + " ml-auto"}
                onClick={() => setCopyColor(value)}
              >
                {icons.copy}
                Copy
              </Button>
              <Button
                className={copyColor ? btnClass : btnClass + " disabled"}
                onClick={() => submitColor(copyColor)}
              >
                {icons.paste}
                Paste
              </Button>
            </div>
          </div>
        </div>
      </>,
      document.body
    );
  };

  const cl = isHilighted ? "ring-4 ring-accent-500/40" : "";

  return (
    <>
      <div
        ref={btnRef}
        onClick={() => {
          setOpen(!open);
        }}
        className={cl + " colorIcon relative cursor-pointer overflow-hidden"}
      >
        <div
          className="absolute inset-0 z-20"
          style={{
            backgroundColor: value,
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.05)",
          }}
        ></div>
        <div className="checkBoard absolute inset-px z-10"></div>
      </div>
      {open && opener()}
    </>
  );
}
